module.exports = __webpack_public_path__ + "static/media/chevron-left.61035ad5.svg";